import React from 'react';
import { motion } from 'framer-motion';
import { ChevronRight } from 'lucide-react';
export function Hero() {
  return <section className="relative pt-20 pb-16 md:pt-32 md:pb-24 overflow-hidden px-4 sm:px-6 lg:px-8" data-id="element-155">
      {/* Decorative background elements */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden -z-10" data-id="element-156">
        <div className="absolute -top-[20%] -right-[10%] w-[70%] h-[70%] rounded-full bg-rose-light/40 blur-3xl" data-id="element-157" />
        <div className="absolute top-[40%] -left-[10%] w-[50%] h-[50%] rounded-full bg-caramel-light/20 blur-3xl" data-id="element-158" />
      </div>

      <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-8 items-center" data-id="element-159">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        ease: 'easeOut'
      }} className="text-center lg:text-left z-10" data-id="element-160">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-caramel/10 text-caramel-dark font-medium text-sm mb-6 border border-caramel/20" data-id="element-161">
            <span className="relative flex h-2 w-2" data-id="element-162">
              <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-caramel opacity-75" data-id="element-163"></span>
              <span className="relative inline-flex rounded-full h-2 w-2 bg-caramel" data-id="element-164"></span>
            </span>
            Lanzamiento Oficial
          </div>

          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-serif font-bold text-espresso leading-tight mb-6" data-id="element-165">
            ¡Convierte tu cocina en tu propio{' '}
            <span className="text-caramel italic" data-id="element-166">negocio rentable</span> este
            mismo fin de semana!
          </h1>

          <p className="text-lg sm:text-xl text-espresso-light mb-8 font-sans max-w-2xl mx-auto lg:mx-0 leading-relaxed" data-id="element-167">
            Domina el arte de las Milhojas y las Galletas Gourmet con mi método
            paso a paso. (Incluso si nunca has encendido un horno profesional).
          </p>

          <div className="flex flex-col sm:flex-row gap-4 justify-center lg:justify-start" data-id="element-168">
            <a href="#cta-final" className="group relative inline-flex items-center justify-center gap-2 px-8 py-4 bg-caramel text-white font-bold text-lg rounded-xl overflow-hidden transition-all hover:bg-caramel-dark hover:shadow-glow hover:-translate-y-1" data-id="element-169">
              <span className="absolute inset-0 w-full h-full bg-white/20 translate-y-full group-hover:translate-y-0 transition-transform duration-300 ease-out" data-id="element-170"></span>
              <span className="relative" data-id="element-171">
                SÍ, QUIERO EMPEZAR MI NEGOCIO DULCE POR $6.36
              </span>
              <ChevronRight className="relative w-5 h-5 group-hover:translate-x-1 transition-transform" data-id="element-172" />
            </a>
          </div>
          <p className="mt-4 text-sm text-espresso-light/80 flex items-center justify-center lg:justify-start gap-2" data-id="element-173">
            <span className="text-caramel" data-id="element-174">★★★★★</span> +1,200 alumnas felices
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.8,
        delay: 0.2,
        ease: 'easeOut'
      }} className="relative w-full flex items-center justify-center z-10" data-id="element-175">
          <motion.img animate={{
          y: [0, -12, 0]
        }} transition={{
          repeat: Infinity,
          duration: 6,
          ease: 'easeInOut'
        }} src="https://cdn.magicpatterns.com/uploads/7iBWSEaiKoNRsRDqqGXp1h/Mockup_Master_Reposteria.png" alt="Master en Repostería en Casa - Milhojas y Galletas Gourmet para Vender" className="w-full max-w-lg mx-auto drop-shadow-2xl" data-id="element-176" />
        </motion.div>
      </div>
    </section>;
}